import { render } from "./LocationsIndex.vue?vue&type=template&id=38218c06"
import script from "./LocationsIndex.vue?vue&type=script&lang=js"
export * from "./LocationsIndex.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__